import { render, staticRenderFns } from "./ContainerTypeMaintain.vue?vue&type=template&id=06521818"
import script from "./ContainerTypeMaintain.vue?vue&type=script&lang=js"
export * from "./ContainerTypeMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports